import { Suspense, lazy } from "react";

import { CRM } from "@/components/atomic-crm/root/CRM";

/**
 * Modo local sem login — SÓ para desenvolvimento.
 *
 * POR QUE EXISTE. Conferir uma tela localmente exigia passar pela tela de
 * login, o que significa ter credencial de alguém à mão. Isso trava a revisão
 * visual de qualquer mudança de layout: o desenvolvedor (ou o agente) muda o
 * quadro do CRM, roda os testes, e não consegue OLHAR o resultado. Foi
 * exatamente o que aconteceu na revisão do funil de três linhas.
 *
 * COMO LIGAR. `VITE_MODO_LOCAL=1` no `web/.env.local` (o `.gitignore` já cobre
 * `.env.*`, então isso nunca vai para o repositório). Depois `npm run dev`.
 *
 * ── POR QUE ISTO NÃO É UM BURACO DE SEGURANÇA ───────────────────────────────
 *
 * São TRÊS travas, e cada uma sozinha já bastaria:
 *
 * 1. `import.meta.env.DEV` é substituído por `false` literal no `npm run
 *    build`. O `if` inteiro vira código morto e o bundler o remove — o modo não
 *    existe no arquivo publicado, não é questão de ninguém conseguir ligá-lo.
 *
 * 2. A variável precisa ser declarada explicitamente. Não há padrão ligado.
 *
 * 3. O que ele monta NÃO é a plataforma sem senha: é a plataforma com dados
 *    FALSOS, gerados na memória do navegador (o provider `fakerest`, que veio
 *    do template). Não há sessão do Supabase, não há chave de serviço, e
 *    nenhuma requisição sai para banco nenhum. Não existe dado real para
 *    vazar porque não existe conexão.
 *
 * A terceira trava é a que importa de verdade e é o motivo de o modo ser este,
 * e não "pular a tela de login e usar o banco de dev". Aquele desenho pediria
 * uma credencial guardada em algum lugar — e credencial guardada em algum lugar
 * é a coisa que a gente passa a vida tirando do repositório.
 *
 * O CUSTO, dito com todas as letras: os dados são inventados, então este modo
 * serve para conferir LAYOUT e fluxo de tela. Não serve para conferir número,
 * consulta, RLS ou qualquer coisa que dependa do banco de verdade — para isso,
 * login normal contra o dev.
 *
 * O carregamento é dinâmico de propósito: o gerador de dados falsos carrega uma
 * biblioteca grande, e um `import` no topo a colocaria no caminho de todo mundo
 * mesmo com o modo desligado.
 */
const ativo = import.meta.env.DEV && import.meta.env.VITE_MODO_LOCAL === "1";

const CrmFalso = lazy(async () => {
  const { authProvider, dataProvider } = await import(
    "@/components/atomic-crm/providers/fakerest"
  );
  return {
    default: () => <CRM authProvider={authProvider} dataProvider={dataProvider} />,
  };
});

/** Uma faixa fixa, para ninguém confundir dado inventado com dado real. */
const Aviso = () => (
  <div className="fixed bottom-0 left-0 z-[100] rounded-tr-md bg-amber-500 px-2.5 py-1 text-[11px] font-semibold text-amber-950 shadow">
    modo local · dados falsos
  </div>
);

export const AppComOuSemLogin = () => {
  if (!ativo) return <CRM />;
  return (
    <Suspense fallback={null}>
      <Aviso />
      <CrmFalso />
    </Suspense>
  );
};
